import { useQuery } from '@tanstack/vue-query';
import { computed, type Ref } from 'vue';
import { loadResourceEventsByDate } from '/@stores/resources';
import type { ResourceEvent } from '/@types/resources';

export function useResourceEventsByDateQuery(fromDate: Ref<Date>, toDate: Ref<Date>) {
  return useQuery<ResourceEvent[]>({
    queryKey: computed(() => [
      'resourceEvents',
      'byDate',
      fromDate.value.toISOString(),
      toDate.value.toISOString(),
    ]),
    queryFn: () => loadResourceEventsByDate(fromDate.value, toDate.value),
    staleTime: 30 * 1000, // 30 seconds
  });
}
